import { SVGPureIcon } from "@/ui";
import { aigcBGMStore } from "../store/bgm-list";
import AigcOptionItem from "./aigc-option-item"
import { aigcFormStore } from "../store";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import BGMItem from "../item/bgm-item";
import { debounce, throttle } from "lodash-es";


const AigcBGMOptions = ({ modelValue, updateModelValue, size = 'normal' }: { modelValue: string, updateModelValue: (item: any) => void, size?: 'normal' | 'mini' }) => {
  const [activeTab, setActiveTab] = useState('all')
  const [pageLength, setPageLength] = useState(20);
  const [shouldScrollIntoView, setShouldScrollIntoView] = useState(false)
  const listRef = useRef<HTMLUListElement>(null)

  const onClick = (e, item) => {
    e.nativeEvent.stopImmediatePropagation()
    updateModelValue(item)
  }
  const onTabChange = (key) => {
    setActiveTab(key)
    listRef.current?.scrollTo({ top: 0, behavior: 'instant' })
    // 让选中项出现在视口内
    const activeItemIdx = aigcFormStore.musicMap[key].findIndex(i => i.id === modelValue)
    if (activeItemIdx < 0) {
      setPageLength(20)
      return
    }
    const ceil = Math.ceil(activeItemIdx + 1 / 20) * 20
    setPageLength(ceil)
    setShouldScrollIntoView(true)
  }

  useLayoutEffect(() => {
    if (!listRef.current || pageLength > aigcFormStore.musicMap[activeTab].length) {
      return
    }
    if (listRef.current.scrollTop + listRef.current.offsetHeight === listRef.current.scrollHeight) {
      setPageLength(prev => prev + 20)
    }
  }, [pageLength])

  useEffect(() => {
    if (shouldScrollIntoView) {
      setShouldScrollIntoView(false)
      const activeItemIdx = aigcFormStore.musicMap[activeTab].findIndex(i => i.id === modelValue)
      listRef.current.children.item(activeItemIdx)?.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  }, [shouldScrollIntoView])


  useEffect(() => {
    if (!aigcFormStore.shownDropdown) {
      aigcBGMStore.pauseAudio()

    }
    if (aigcFormStore.shownDropdown === 'bgm') {
      onTabChange(aigcFormStore.listData.musicMap.marks_and_tags[0].key)
    }
  }, [aigcFormStore.shownDropdown])

  const onScroll = throttle(() => {
    if (!listRef.current || pageLength > aigcFormStore.musicMap[activeTab].length) {
      return
    }
    const list = listRef.current
    if (list.offsetHeight + list.scrollTop > list.scrollHeight - 100) {
      setPageLength(prev => prev + 20)
    }
  }, 100)


  return (
    <div className="flex flex-col h-0 flex-1">
      <ul className="flex flex-wrap gap-6px">
        {
          aigcFormStore.listData.musicMap.marks_and_tags.map(item => item.key === 'favorite' || item.key === 'used' || aigcFormStore.musicMap[item.key]?.length ? (
            <li
              key={item.key}
              style={{
                '--tw-from-opacity': '.1',
                '--tw-via-opacity': '.1',
                '--tw-to-opacity': '.1'
              }}
              className={`flex-shrink-0 transition-colors duration-300 border-box flex items-center h-26px px-16px cursor-pointer rounded-4px text-12px border-1px hover:bg-[#1D2129] hover:bg-opacity-4
            ${activeTab === item.key ? ' bg-gradient-to-r from-[rgba(119,116,255,0.10)] via-[rgba(1,127,253,0.10)] to-[rgba(1,177,253,0.10)] border-transparent' : ' border-[rgba(29, 33, 41, 0.10)]'}`}
              onClick={onTabChange.bind(null, item.key)}
            >
              <span
                style={{
                  '--tw-from-opacity': '1',
                  '--tw-via-opacity': '1',
                  '--tw-to-opacity': '1'
                }}
                className={`font-500 ${activeTab === item.key ? 'bg-gradient-to-r from-[#605DFF] via-[#0070DF] to-[#00A7EF] text-transparent bg-clip-text' : 'font-400'}`}>
                {item.name}
              </span>
            </li>
          ) : null)
        }
      </ul>
      {
        aigcFormStore.musicMap[activeTab]?.length ?
          <ul
            ref={listRef}
            className='h-0 mb-0 flex-1 -m-2px content-start p-2px gap-8px pr-14px overflow-y-scroll nw-scrollbar nw-scrollbar grid grid-cols-3 items-start'
            onScroll={onScroll}
          >
            {
              (activeTab === 'favorite' || activeTab === 'used' ?
                  aigcFormStore.musicMap[activeTab].sort((a, b) =>
                    +b.marks.find(mark => mark.key === activeTab).timestamp
                    - +a.marks.find(mark => mark.key === activeTab).timestamp
                  ) : aigcFormStore.musicMap[activeTab])
                .slice(0, pageLength)
                .map(item => (
                  <BGMItem size={size} key={item.id} isActive={modelValue === item.id} item={item} onClick={onClick} />
                ))
            }
          </ul> :
          <div className="gap-16px flex-1 flex items-center justify-center">
            <div className="flex justify-center items-center flex-col ">
              <img src='https://p0.ssl.qhimg.com/t110b9a93018ddbe5c37c5c3b38.png' className="w-200px h-144px " />
              <p className="flex-1 h-0 text-12px text-[rgba(0,0,0,0.50)]">暂无{`${activeTab === 'used' ? '用过的' : '收藏的'}`}音乐</p>
            </div>
          </div>
      }
    </div>
  )
}

export default observer(AigcBGMOptions)